export const translucentDialogSurfaceClassName =
  'rounded-3xl border border-white/60 bg-mist-165/90 p-7 shadow-[0_24px_64px_-16px_rgba(15,24,52,0.35)] ring-1 ring-slate-400/20 dark:border-white/10 dark:bg-navy-740/90 dark:ring-white/[0.06]';
